<template>
  <section>
    <b-modal :id="modalId" hide-header hide-footer size="xl">
      <offer-header :modalId="modalId" :sourcedObj="sourcedObj" :offerId="offerId" :companyId="companyId" :partId="partId" :lineId="lineId" @onDone="onDone" @part-value="$emit('part-value', $event)" />
      <!-- <tabs v-if="offerId" /> -->
    </b-modal>
  </section>
</template>

<script>
import OfferHeader from './components/OfferHeader/index';
import Tabs from './components/Tabs';
import { mapMutations } from 'vuex';

export default {
  components: {
    OfferHeader,
    Tabs,
  },
  props: {
    offerId: [Number, String],
    companyId: [Number, String],
    partId: [Number, String],
    lineId: [Number, String],
    modalId: {
      type: String,
      default: 'offer-form-modal'
    },
    sourcedObj: [Object],
  },
  methods: {
    onDone(e) {
      this.$emit('onCloseModal', e);
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
